import React from 'react';
import { withStyles } from '@material-ui/styles';
import logo from '../system/images/logo_sm.svg';

// import cx from 'clsx';
// import _get from 'lodash/get';
// import _set from 'lodash/set';

const styles = theme => ({});

const LogoSm = props => {
    // const classes = _get(props, 'classes');

    // return <img src={logo_sm} alt="logo" {...props} />;
    return (
        <span>
            <img src={logo} width="36px" alt="A Foot in the Door App Icon" />
        </span>
    );
};

export default withStyles(styles)(LogoSm);
